<template>
  <div :style="{ color: color }">
    {{ renderCell(type, value) }}
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DataCell',
  props: {
    type: String,
    value: [String, Number, Boolean, Object]
  },
  data() {
    return {
      color: null
    }
  },
  methods: {
    renderCell(type, value) {
      if (type == 'text') {
        return value
      }
      if (type == 'date') {
        if (value) {
          let date = moment(value)
          if (date > 0)
            return (
              date.format() +
              (moment().diff(date, 'days') ? '' : ' (' + date.fromNow() + ')')
            )
        }
        return '--' // Not started or Timestamp 0
      }
      if (type == 'duration') {
        let date = moment.duration(value)
        if (Math.floor(date.asMinutes())) {
          return Math.floor(date.asMinutes()) + 'm ' + date.seconds() + 's'
        } else {
          return date.seconds() + 's'
        }
      }
      if (type == 'color') {
        this.color = value
        return value
      }
      if (type == 'boolean') {
        if (value) {
          return '✔️'
        } else {
          return '❌'
        }
      }
    }
  }
}
</script>
